import globalAxios from 'axios';
import config from '../config';
import store from '../store';

const axios = globalAxios.create({
    baseURL: config.apiUrl,
    withCredentials: true
});

axios.interceptors.response.use(
    response => {
        axios.defaults.headers.common['XSRF-TOKEN'] = response.headers['xsrf-token'] || '';

        const key = 'version';
        const currentVersion = store.getters['versions/getCmsVersion'];
        const version = response.headers[key] || '';
        let appsVersions = {};

        version.split(';').map(appVersion => {
            const versionParts = appVersion.split(':')
            appsVersions[versionParts[0]] = versionParts[1];
        });

        const newVersion = appsVersions.cms;

        if (newVersion && (!currentVersion || currentVersion !== newVersion)) {
            store.commit('versions/setCmsVersion', newVersion);
        }

        if (currentVersion && newVersion && newVersion !== currentVersion) {
            store.commit('versions/setShouldUpdate', true);
        }

        return response;
    },
    error => {
        const loggedUser = store.getters['auth/getLoggedUser'];

        if (!error.response) {
            if (!loggedUser) {
                window.location.href = '/login';
                localStorage.clear();
            }

            throw error;
        }

        axios.defaults.headers.common['XSRF-TOKEN'] =
            error.response.headers['xsrf-token'] || '';

        const errResponseUrl = error.response.request.responseURL;
        const fromUrl = errResponseUrl.split('/').pop();
        const nonRedirectUrls = ['login', 'forgot-password', 'reset-password'];

        if (
            error.response.status === 401 &&
            !nonRedirectUrls.includes(fromUrl)
        ) {
            window.location.href = '/login';
            localStorage.clear();
        }

        throw error;
    }
);

export default axios;
